export const convertDate = (date: any) => {
    const istDate = new Date(date).toLocaleString("en-IN", {
        timeZone: "Asia/Kolkata",
    });
    return istDate;
}
export function getDateFromISO(date: string) {
    if (!date) return "";
    const d = new Date(date);
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
}
export function isoToVerbalDate(isoString: string): string {
    const date = new Date(isoString);

    const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun",
        "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

    const day = date.getDate();
    const month = months[date.getMonth()];
    const year = date.getFullYear();

    return `${month} ${day}, ${year}`;
}

export function isoToVerbalDateTime(isoString: string): string {
    const date = new Date(isoString);

    // Month abbreviations
    const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun",
        "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

    const day = date.getDate();
    const month = months[date.getMonth()];
    const year = date.getFullYear();

    // Format time in 12-hour format
    let hours = date.getHours();
    const minutes = date.getMinutes();
    const ampm = hours >= 12 ? "PM" : "AM";
    hours = hours % 12;
    hours = hours ? hours : 12; // convert 0 → 12
    const minutesStr = minutes.toString().padStart(2, "0");

    return `${month} ${day}, ${year} ${hours}:${minutesStr} ${ampm}`;
}

export function formatDateTime(dateInput: Date | string): string {
    const date = typeof dateInput === "string" ? new Date(dateInput) : dateInput;

    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");

    let hours = date.getHours();
    const minutes = String(date.getMinutes()).padStart(2, "0");

    const ampm = hours >= 12 ? "PM" : "AM";
    hours = hours % 12;
    hours = hours ? hours : 12; // 0 -> 12

    const hourStr = String(hours).padStart(2, "0");

    return `${year}-${month}-${day} ${hourStr}:${minutes} ${ampm}`;
}


export function formatDate(dateInput: Date | string): string {

    const date = typeof dateInput === "string" ? new Date(dateInput) : dateInput;

    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");

    return `${year}-${month}-${day}`;
}

export function formatTime(dateInput: Date | string): string {

    const date = typeof dateInput === "string" ? new Date(dateInput) : dateInput;

    let hours = date.getHours();
    const minutes = String(date.getMinutes()).padStart(2, "0");

    const ampm = hours >= 12 ? "PM" : "AM";
    hours = hours % 12;
    hours = hours ? hours : 12; // 0 -> 12

    const hourStr = String(hours).padStart(2, "0");

    return `${hourStr}:${minutes} ${ampm}`;
}


export function formatDateTimeA(dateInput: Date | string): string[] {

    const date = typeof dateInput === "string" ? new Date(dateInput) : dateInput;

    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");

    let hours = date.getHours();
    const minutes = String(date.getMinutes()).padStart(2, "0");

    // const ampm = hours >= 12 ? "PM" : "AM";
    // hours = hours % 12;
    // hours = hours ? hours : 12; // 0 -> 12

    const hourStr = String(hours).padStart(2, "0");

    return [`${year}-${month}-${day}`, `${hourStr}:${minutes}`];
}
